export default axios => ({
  getList(user) {
    return axios.get(`/documents/${user}/list`);
  },
  editFileData (userId, documentId, payLoad) {
    return axios.patch(`/documents/${userId}/list/${documentId}`, payLoad);
  }
})
